"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _tableText = _interopRequireDefault(require("./table-text"));

var _tableSteps = _interopRequireDefault(require("../styles/table-steps.css"));

var _tableSteps2 = _interopRequireDefault(require("./table-steps.props/table-steps.defaultProps"));

var _tableSteps3 = _interopRequireDefault(require("./table-steps.props/table-steps.propTypes"));

/**
 * ## TableSteps - component
 *
 * Some really cool piece of description goes here.
 */
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
    handleNestedProp = dataUtils.handleNestedProp;

var TableSteps = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(TableSteps, _React$Component);

  TableSteps.resourceType = function resourceType() {
    return 'TableSteps_1_0_0';
  };

  function TableSteps(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      anchorMap: []
    };
    return _this;
  }

  var _proto = TableSteps.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var data = this.props.data;
    var categories = handleNestedProp(data, 'data.categories');
    var anchorMap = [];
    var components = null;

    if (categories && categories !== ' ' && categories.length > 0 && typeof document !== 'undefined') {
      categories.forEach(function (category, i) {
        if (category.textSection && category.textSection.anchorPoint && category.textSection.anchorPoint !== '') {
          var anchorPoint = category.textSection.anchorPoint;

          if (document.getElementById(anchorPoint)) {
            anchorMap.push({
              categoryIndex: i,
              anchorPoint: anchorPoint
            });
          } else {
            if (components === null) {
              components = document.getElementsByTagName('main');

              if (components && components.length) {
                components = document.getElementsByTagName('main')[0].childNodes;
              }
            }

            var anchorPointParts = anchorPoint.split('_');
            var anchorIndex = Number(anchorPointParts.pop());
            var resourceType = anchorPointParts.join('_');
            var closestIndex = 0;
            components.forEach(function (component) {
              var componentId = component.getAttribute('id');

              if (componentId.includes(resourceType)) {
                var compIndex = Number(componentId.match(/[0-9]+$/));

                if (Math.abs(compIndex - anchorIndex) < Math.abs(closestIndex - anchorIndex)) {
                  closestIndex = compIndex;
                }
              }
            });
            anchorMap.push({
              categoryIndex: i,
              anchorPoint: resourceType + "_" + closestIndex
            });
          }
        }
      });
      this.setState({
        anchorMap: anchorMap
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        data = _this$props.data,
        theme = _this$props.theme,
        defaultData = _this$props.defaultData;
    var anchorMap = this.state.anchorMap;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    var breakPoint = 4;
    var gridColumns = 12;
    var categoriesLength = 0;
    var categories = handleNestedProp(componentData, 'componentData.categories');

    if (categories) {
      categoriesLength = categories.length;
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _tableSteps["default"].noGutters + " " + _tableSteps["default"].noGutters,
      automation: "automationValue"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _tableSteps["default"].noGutters + " " + _tableSteps["default"].noGutters
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-offset-1'] + " " + theme['col-sm-10'] + " " + _tableSteps["default"].spacialPadding
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _tableSteps["default"].noGutters,
      automation: "automationValue"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _tableSteps["default"].noGutters
    }, categoriesLength < breakPoint && categories && categories.map(function (oneCategory, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: theme['col-xs-12'] + " " + theme["col-sm-" + gridColumns / categoriesLength],
        key: oneCategory.heading
      }, /*#__PURE__*/_react["default"].createElement(_tableText["default"], {
        oneCategory: oneCategory,
        anchor: anchorMap.find(function (point) {
          return point.categoryIndex === index;
        }),
        index: index,
        theme: theme,
        disclaimerData: componentData.disclaimerData
      }));
    }), categoriesLength === breakPoint && categories && categories.map(function (oneCategory, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: theme['col-xs-12'] + " " + theme['col-sm-6'] + " " + theme['col-md-3'],
        key: oneCategory.heading
      }, /*#__PURE__*/_react["default"].createElement(_tableText["default"], {
        oneCategory: oneCategory,
        anchor: anchorMap.find(function (point) {
          return point.categoryIndex === index;
        }),
        index: index,
        theme: theme,
        disclaimerData: componentData.disclaimerData
      }));
    }), categoriesLength > breakPoint && categories && categories.map(function (oneCategory, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: theme['col-xs-12'] + " " + theme['col-sm-4'],
        key: oneCategory.heading
      }, /*#__PURE__*/_react["default"].createElement(_tableText["default"], {
        oneCategory: oneCategory,
        anchor: anchorMap.find(function (point) {
          return point.categoryIndex === index;
        }),
        index: index,
        theme: theme,
        disclaimerData: componentData.disclaimerData
      }));
    }))))));
  };

  return TableSteps;
}(_react["default"].Component);

exports["default"] = TableSteps;
TableSteps.displayName = 'TableSteps';
TableSteps.defaultProps = {
  data: _tableSteps2["default"],
  defaultData: _tableSteps2["default"],
  theme: {}
};